<template>
  <v-avatar
    size="130px"
    slot="activator"
    @mouseover="mouseHovered = true"
    @mouseleave="mouseHovered = false"
  >
    <img :src="user.image" />
    <div v-show="mouseHovered" class="editLayer">
      <div style="background: #585858;opacity: 0.2;" class="editLayer"></div>
      <v-btn icon class="white teal--text" @click="$refs.inputFile.click()">
        <v-icon>edit</v-icon>
      </v-btn>
      <input
        type="file"
        ref="inputFile"
        data-vv-as="عکس"
        accept="image/*"
        style="display: none"
        @change="onFileChange"
        data-vv-name="userPhoto"
        v-validate="'required|size:4000'"
      />
    </div>
  </v-avatar>
</template>
<script>
export default {
  data() {
    return {
      roles: [],
      item: null,
      loading: false,
      mouseHovered: false
    };
  },
  computed: {
    deviceClasses() {
      if (this.$vuetify.breakpoint.mdAndUp)
        return {
          lay1: "primary",
          icon: "mb-5 align-center"
        };
      return {
        lay1: "primary",
        icon: "mb-5 align-center"
      };
    },
    user() {
      return this.$store.getters["AuthModule/current_user"]["user"];
    }
  },
  methods: {
    onFileChange() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let formData = new FormData();
          formData.append("image", this.$refs.inputFile.files[0]);
          this.axios.post("upload", formData).then(resp => {
            let currentUser = this.$store.getters["AuthModule/current_user"];
            currentUser.user.image = resp.data;
            localStorage.setItem("currentUser", JSON.stringify(currentUser));
          });
          this.createImage(this.$refs.inputFile.files[0]);
        } else {
          this.$store.commit("showSnackbar", {
            show: true,
            stateType: "error",
            text: this.errors.collect("userPhoto").toString()
          });
        }
      });
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = e => {
        vm.user.image = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }
};
</script>

<style>
.editLayer {
  width: 130px;
  height: 130px;
  position: absolute;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
</style>
